// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import api from './api/index'
import utils from './utils'
import global_ from "./global/index"
// import { Loading } from 'element-ui';
import axios from 'axios'
import store from './store'
import '../static/ueditor/ueditor.config.js'
import '../static/ueditor/ueditor.all.js'
import '../static/ueditor/lang/zh-cn/zh-cn.js'
import '../static/ueditor/ueditor.parse.js'
import '../static/ueditor/point-plugin/fontPoint.js'
import '../static/ueditor/emptyunderline-plugin/emptyUnderLine.js'
import '../static/ueditor/kityformula-plugin/addKityFormulaDialog.js'
import '../static/ueditor/kityformula-plugin/getKfContent.js'
import '../static/ueditor/kityformula-plugin/defaultFilterFix.js'
import '../static/css/element-variables.css'
import '../static/css/swiper-bundle.min.css'
import fabric from 'fabric'
import EasyBar from '../static/js/easy-bar.common.js'
import 'video.js/dist/video-js.css'

Vue.use(fabric)
Vue.use(EasyBar)

console.log('sso---->', window.sso);
window.sso.event('logged', (user) => {
  console.log('ssssssssssssssssssssssssssssssssssssssssssssssss', user.getUsername());
  window.localStorage.setItem('user_no', user.getUsername());
});

router.beforeEach((to, from, next) => {

  console.log('process.env.NODE_ENV', process.env.NODE_ENV);
  var url = "";
  if (process.env.NODE_ENV=='development') {
    url = '/sso' + '/api/admin/base/getLoginUserInfoBySession'
  } else if (process.env.NODE_ENV=='testing') {
    url = global_.global.test_url + '/api/admin/base/getLoginUserInfoBySession'
  } else {
    // 线上地址
    url =  global_.global.online_url + '/api/admin/base/getLoginUserInfoBySession'
  }
  let loadingInstance = ElementUI.Loading.service({ fullscreen: true ,text:'加载中',background:'rgba(0,0,0,0.5)'});
  window.sso.ready().then(user => {
    axios.get(url).then(function(data){
        loadingInstance.close();
        if (data.data.retcode==0){
          // window.localStorage.setItem('user_no',data.data.data)
          // window.localStorage.setItem('admin_id',data.data.data.admin_id)
          // window.localStorage.setItem('store_name',data.data.data.store_name)
          // window.localStorage.setItem('store_id',data.data.data.store_id)
          next();
        }else if(data.data.retcode==1002){
          var url2 = window.location.href;
          window.location.href =data.data.url+'&ref='+ encodeURIComponent(url2) ;
        }
    }).catch((error) =>{
        loadingInstance.close();
        console.log('error', JSON.stringify(error.response, null, 4));
        if (error.response) {
            if(!user.isNotLogin(error.response.status,error.response.headers)){
                console.log('网络不给力，请稍后重试');
            }
        } else {
          console.log('Error', error.message);
        }
    })
  });
})

Vue.prototype.quitSystem = function(){
    // var that = this;
   	// console.log('请求退出')
    // that.$api.SIGNOUT({}).then((res) => {
    //     if (res.retcode==0){
    //     	window.location.href = res.url;
    //     }else{
    //         that.$message.error(res.msg);
    //     }
    // })
    window.sso.ready().then(function (user) {
      //设置退出登录的点击事件
  		user.logout();
  	});
}


Vue.use(ElementUI)
Vue.use(api)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  api,
  store,
  components: { App },
  beforeCreate () {
    Vue.prototype.$bus = this
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js